<template>
    <el-select v-model="value">
      <el-option 
        v-for="item in levelData" 
        :key="item.id" 
        :value="item.id"
        :label="item.name"
      ></el-option>
    </el-select>
</template>

<script>
export default {
  name: 'Subject',
  data() {
    return {
      levelData: [],
      value: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getLevel().then(data => {
        this.levelData = data
      })
    }
  }
}
</script>

<style>

</style>